import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { DomainsService } from '../../../../services/domains.service';
import { UsersService } from '../../../../services/users.service';
import { NotificationsService } from '../../../../services/notifications.service';

@Component({
  selector: 'app-ns-kpis',
  standalone: true,
  imports: [CommonModule, RouterLink, ProgressSpinnerModule, ButtonModule],
  templateUrl: './ns-kpis.component.html',
  styleUrls: ['./ns-kpis.component.scss'],
})
export class NsKpisComponent implements OnInit {
  private readonly domainsService = inject(DomainsService);
  private readonly usersService = inject(UsersService);
  private readonly notifications = inject(NotificationsService);

  protected loading = false;
  protected error = false;
  protected domainsCount: number | null = null;
  protected usersCount: number | null = null;

  ngOnInit(): void {
    this.fetch();
  }

  protected fetch(): void {
    this.loading = true;
    this.error = false;

    forkJoin({
      domains: this.domainsService.getDomainsCount(),
      users: this.usersService.getUsersCount(),
    }).subscribe({
      next: ({ domains, users }) => {
        this.domainsCount = domains.total;
        this.usersCount = users.total;
        this.loading = false;
      },
      error: (err) => {
        this.error = true;
        this.loading = false;
        this.notifications.error(err);
      },
    });
  }
}
